const obj = {
  answerPageData: {},
  // 当前选中的切题
  attach: {},
  // 当前选中切题的questionId
  questionId: '',
  isAdd: false
}
export default {
  namespaced: true,
  state: JSON.parse(JSON.stringify(obj)),
  mutations: {
    commit_answerPageData(state, data) {
      state.answerPageData = data
    },
    commit_attach(state, data) {
      state.attach = data
    },
    commit_questionId(state, data) {
      state.questionId = data
    },
    commit_isAdd(state, data) {
      state.isAdd = data
    },
    clearStore(state) {
      Object.keys(obj).forEach((key) => {
        state[key] = obj[key]
      })
    }
  }
}
